// Segmented Workers | History switch for the two worker landing surfaces.
//
// Route-backed (so each view is bookmarkable) rather than a stateful
// Tabs widget. Styled like the shadcn TabsList for visual continuity:
// a hairline-bordered track with the active segment lifted onto the
// page background. No nested card, no animated color transitions.

import { cn } from "@veil/ui/lib/utils";
import { Link } from "wouter";

type WorkerView = "workers" | "history";

const ITEMS: ReadonlyArray<{ view: WorkerView; href: string; label: string }> =
	[
		{ view: "workers", href: "/workers", label: "Workers" },
		{ view: "history", href: "/workers/history", label: "History" },
	];

export function WorkerViewTabs({ active }: { active: WorkerView }) {
	return (
		<nav
			aria-label="Worker view"
			className="inline-flex items-center gap-0.5 rounded-lg border border-border/60 bg-muted/50 p-0.5"
		>
			{ITEMS.map((item) => {
				const isActive = item.view === active;
				return (
					<Link
						key={item.view}
						href={item.href}
						aria-current={isActive ? "page" : undefined}
						className={cn(
							"rounded-md px-3 py-1 text-sm font-medium",
							isActive
								? "bg-background text-foreground shadow-sm"
								: "text-muted-foreground hover:text-foreground",
						)}
					>
						{item.label}
					</Link>
				);
			})}
		</nav>
	);
}
